import { useState } from "react"
import { Link } from "react-router-dom"
import { supabaseClient } from "@/lib/supabase/client"
import { useToast } from "@/components/ui/ToastProvider"
import { IconLoader } from "@/components/ui/Icons"

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("")
  const [loading, setLoading] = useState(false)
  const [sent, setSent] = useState(false)
  const { success, error: showError } = useToast()

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setLoading(true)
    try {
      const { error } = await supabaseClient.auth.resetPasswordForEmail(email, {
        redirectTo: window.location.origin + "/auth/reset-password",
      })
      if (error) { showError("Error", error.message); return }
      success("Check your email", "We sent a reset link.")
      setSent(true)
    } finally { setLoading(false) }
  }

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="w-full max-w-[350px] space-y-3">
        <div className="auth-card text-center">
          {sent ? (
            <div className="py-4">
              <p className="text-2xl mb-2">📬</p>
              <p className="font-semibold">Email sent!</p>
              <p className="text-text-muted text-sm mt-1">Check your inbox for a reset link.</p>
            </div>
          ) : (
            <>
              <div className="mb-4">
                <div className="w-12 h-12 rounded-full border-2 border-border flex items-center justify-center mx-auto mb-3">
                  <svg className="w-6 h-6 text-text-muted" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" /></svg>
                </div>
                <h2 className="font-semibold text-base">Trouble logging in?</h2>
                <p className="text-text-muted text-sm mt-1">Enter your email and we'll send you a link to reset your password.</p>
              </div>
              <form onSubmit={handleSubmit} className="space-y-3">
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} placeholder="Email" className="input-ig" required />
                <button type="submit" disabled={loading} className="btn-ig w-full py-2.5">
                  {loading ? <IconLoader className="w-4 h-4 animate-spin" /> : "Send reset link"}
                </button>
              </form>
              <div className="divider-ig mt-4"><span className="text-text-muted text-xs">or</span></div>
              <Link to="/auth/register" className="block mt-3 font-semibold text-sm text-foreground hover:opacity-80">Create new account</Link>
            </>
          )}
        </div>
        <div className="auth-card text-center py-4">
          <Link to="/auth/login" className="text-sm font-semibold">Back to login</Link>
        </div>
      </div>
    </div>
  )
}